<template>
    <div>
        <NewHeader></NewHeader>
        <div class="container bg-neutral-900 mt-[68px] md:mt-[88px] py-5">
            <div class="last-updated">{{ t('privacy.last_updated') }}</div>
            <h1>{{ t('privacy.introduction.title') }}</h1>
            <p>
                {{ t('privacy.introduction.paragraph_1') }}
            </p>
            <p>
                {{ t('privacy.introduction.paragraph_2') }}
            </p>

            <h2>{{ t('privacy.sections.section_1.title') }}</h2>
            <h3>{{ t('privacy.sections.section_1.subsection_1_1.title') }}</h3>
            <ul>
                <li>
                    <strong>{{ t('privacy.sections.section_1.subsection_1_1.items.photos_gifs_videos.label') }}:</strong> {{ t('privacy.sections.section_1.subsection_1_1.items.photos_gifs_videos.content') }}
                </li>
                <li>
                    <strong>{{ t('privacy.sections.section_1.subsection_1_1.items.facial_features.label') }}:</strong> {{ t('privacy.sections.section_1.subsection_1_1.items.facial_features.content') }}
                </li>
                <li>
                    <strong>{{ t('privacy.sections.section_1.subsection_1_1.items.email_address.label') }}:</strong> {{ t('privacy.sections.section_1.subsection_1_1.items.email_address.content') }}
                </li>
            </ul>

            <h3>{{ t('privacy.sections.section_1.subsection_1_2.title') }}</h3>
            <ul>
                <li>
                    <strong>{{ t('privacy.sections.section_1.subsection_1_2.items.usage_details.label') }}:</strong> {{ t('privacy.sections.section_1.subsection_1_2.items.usage_details.content') }}
                </li>
                <li>
                    <strong>{{ t('privacy.sections.section_1.subsection_1_2.items.device_information.label') }}:</strong> {{ t('privacy.sections.section_1.subsection_1_2.items.device_information.content') }}
                </li>
            </ul>

            <h2>{{ t('privacy.sections.section_2.title') }}</h2>
            <p>
                {{ t('privacy.sections.section_2.intro') }}
            </p>
            <ul>
                <li>
                    <strong>{{ t('privacy.sections.section_2.items.cookies.label') }}:</strong> {{ t('privacy.sections.section_2.items.cookies.content') }}
                </li>
                <li>
                    <strong>{{ t('privacy.sections.section_2.items.web_beacons.label') }}:</strong> {{ t('privacy.sections.section_2.items.web_beacons.content') }}
                </li>
            </ul>

            <h2>{{ t('privacy.sections.section_3.title') }}</h2>
            <h3>{{ t('privacy.sections.section_3.subsection_3_1.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_3.subsection_3_1.content') }}
            </p>
            <h3>{{ t('privacy.sections.section_3.subsection_3_2.title') }}</h3>
            <p>{{ t('privacy.sections.section_3.subsection_3_2.intro') }}</p>
            <ul>
                <li>
                    {{ t('privacy.sections.section_3.subsection_3_2.items.provide_service') }}
                </li>
                <li>{{ t('privacy.sections.section_3.subsection_3_2.items.fulfill_purpose') }}</li>
                <li>
                    {{ t('privacy.sections.section_3.subsection_3_2.items.fulfill_obligations') }}
                </li>
                <li>
                    {{ t('privacy.sections.section_3.subsection_3_2.items.notify_updates') }}
                </li>
            </ul>
            <h3>{{ t('privacy.sections.section_3.subsection_3_3.title') }}</h3>
            <p>{{ t('privacy.sections.section_3.subsection_3_3.intro') }}</p>
            <ul>
                <li>{{ t('privacy.sections.section_3.subsection_3_3.items.estimate_audience') }}</li>
                <li>{{ t('privacy.sections.section_3.subsection_3_3.items.store_preferences') }}</li>
                <li>{{ t('privacy.sections.section_3.subsection_3_3.items.speed_searches') }}</li>
                <li>{{ t('privacy.sections.section_3.subsection_3_3.items.recognize_users') }}</li>
            </ul>
            <p>
                {{ t('privacy.sections.section_3.subsection_3_3.conclusion') }}
            </p>

            <h2>{{ t('privacy.sections.section_4.title') }}</h2>
            <h3>{{ t('privacy.sections.section_4.subsection_4_1.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_4.subsection_4_1.intro') }}
            </p>
            <ul>
                <li>
                    <strong>{{ t('privacy.sections.section_4.subsection_4_1.items.firebase.label') }}:</strong> {{ t('privacy.sections.section_4.subsection_4_1.items.firebase.content') }}
                </li>
            </ul>
            <p>
                {{ t('privacy.sections.section_4.subsection_4_1.conclusion') }}
            </p>
            <h3>{{ t('privacy.sections.section_4.subsection_4_2.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_4.subsection_4_2.content') }}
            </p>

            <h2>{{ t('privacy.sections.section_5.title') }}</h2>
            <h3>{{ t('privacy.sections.section_5.subsection_5_1.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_5.subsection_5_1.content') }}
            </p>
            <h3>{{ t('privacy.sections.section_5.subsection_5_2.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_5.subsection_5_2.content') }}
            </p>

            <h2>{{ t('privacy.sections.section_6.title') }}</h2>
            <p>
                {{ t('privacy.sections.section_6.intro') }}
            </p>
            <ul>
                <li>{{ t('privacy.sections.section_6.items.subsidiaries') }}</li>
                <li>
                    {{ t('privacy.sections.section_6.items.contractors') }}
                </li>
                <li>
                    {{ t('privacy.sections.section_6.items.buyers') }}
                </li>
                <li>{{ t('privacy.sections.section_6.items.fulfill_purpose') }}</li>
                <li>{{ t('privacy.sections.section_6.items.other_purpose') }}</li>
                <li>{{ t('privacy.sections.section_6.items.with_consent') }}</li>
                <li>
                    {{ t('privacy.sections.section_6.items.comply_legal') }}
                </li>
                <li>{{ t('privacy.sections.section_6.items.enforce_rights') }}</li>
                <li>
                    {{ t('privacy.sections.section_6.items.protect_safety') }}
                </li>
            </ul>

            <h2>{{ t('privacy.sections.section_7.title') }}</h2>
            <h3>{{ t('privacy.sections.section_7.subsection_7_1.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_7.subsection_7_1.content') }}
            </p>
            <h3>{{ t('privacy.sections.section_7.subsection_7_2.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_7.subsection_7_2.content') }}
            </p>
            <h3>{{ t('privacy.sections.section_7.subsection_7_3.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_7.subsection_7_3.content') }}
            </p>
            <h3>{{ t('privacy.sections.section_7.subsection_7_4.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_7.subsection_7_4.content') }}
            </p>
            <h3>{{ t('privacy.sections.section_7.subsection_7_5.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_7.subsection_7_5.paragraph_1') }}
            </p>
            <p>
                {{ t('privacy.sections.section_7.subsection_7_5.paragraph_2') }}
            </p>

            <h2>{{ t('privacy.sections.section_8.title') }}</h2>
            <h3>{{ t('privacy.sections.section_8.subsection_8_1.title') }}</h3>
            <p>
                {{ t('privacy.sections.section_8.subsection_8_1.content') }}
            </p>

            <h2>{{ t('privacy.sections.section_9.title') }}</h2>
            <p>
                {{ t('privacy.sections.section_9.content') }}
            </p>

            <h2>{{ t('privacy.sections.section_10.title') }}</h2>
            <p>
                {{ t('privacy.sections.section_10.content_before_link') }} <NuxtLink to="/contact" class="underline-offset-4 underline">{{ t('privacy.sections.section_10.contact_link_text') }}</NuxtLink> {{ t('privacy.sections.section_10.content_after_link') }}
            </p>
        </div>
        <NewFooter></NewFooter>
    </div>

</template>

<script setup>
import NewHeader from '~/components/NewHeader';
import NewFooter from '~/components/NewFooter';

const { t } = useI18n();

useHead({
    title: t('privacy.page_title'),
    meta: [
        {
            name: 'description',
            content: t('privacy.page_description')
        }
    ]
});
</script>

<style scoped>
body {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 0;
    padding: 0;
    background-color: #f4f4f4;
}

.container {
    max-width: 1280px;
    margin: 20px auto;
    padding: 40px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1,
h2,
h3 {
    color: #fff;
}

h1 {
    font-size: 24px;
    margin-bottom: 20px;
}

h2 {
    font-size: 20px;
    margin-top: 20px;
}

h3 {
    font-size: 18px;
    margin-top: 15px;
}

p {
    margin: 10px 0;
}

ul {
    margin: 10px 0 10px 20px;
}

li {
    margin: 5px 0;
}

.last-updated {
    text-align: right;
    font-size: 12px;
    color: #666;
}
</style>